<script lang="ts">
	import { postReq } from '../../services/http';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from '../../helpers/interface_helpers';
	import { format } from '../../services/i18n';

	//Design system components
	import {
		toast,
		Input,
		Toggle,
		Checkbox,
		Button,
		IconButton,
		Text,
		Container,
	} from '@Shelly/shelly-design-system';

	export let device;

	const min = 0;
	const max = 100;
	const unit = '%';

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	$: statusStore = getDeviceStatus(device.id);
	$: status = $statusStore;
	$: favorites = settings.favorites;
	$: enabled = settings.favorites_enabled;

	$: calibrated =
		status.rollers[device.channel].current_pos < 101 &&
		status.rollers[device.channel].current_pos >= 0;

	const get_current_position = async (i, favorite) => {
		favorites[i] = {
			...favorite,
			pos:
				status.rollers[device.channel].current_pos > 100
					? 0
					: status.rollers[device.channel].current_pos,
		};
	};

	const handle_save = async (i, favorite) => {
		favorite.pos = +favorite.pos;
		if (!favorite.name) {
			favorite.name = '';
		}

		const res = await postReq('device/generic_command', {
			id: device.id,
			command: 'favorites',
			payload: JSON.stringify({ id: i, ...favorite }),
		});

		if (res.isok) {
			settings.favorites[i] = favorite;
			devices_settings.update_devices_settings(device.id, settings);
			toast.open({
				type: 'success',
				title:
					$format('favorite_save_scc_toast', {
						values: { favorite_name: favorite.name },
					}) || `${favorite.name} is saved.`,
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};

	const handle_enable = async () => {
		const res = await postReq('device/generic_command', {
			id: device.id,
			command: 'favorites_enable',
			payload: JSON.stringify({ enabled: enabled ? 0 : 1 }),
		});
		if (res.isok) {
			enabled = !enabled;
			settings.favorites_enabled = enabled;
			devices_settings.update_devices_settings(device.id, settings);
			toast.open({
				type: 'success',
				title: enabled
					? $format('favorites_enabled_scc_toast')
					: $format('favorites_disabled_scc_toast') ||
						`Favorites are ${enabled ? 'enabled' : 'disabled'}.`,
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};
</script>

{#if $showNewLayout}
	<Toggle class="mb-m" checked={enabled} on:click={handle_enable} size="l" id="checkbox-xr9ep5h">
		{$format('favorite_posiotions')}
	</Toggle>
	{#if enabled}
		{#each favorites as favorite, i}
			<div>
				<Text styleType="h2" class="text-500 mb-s-plus">Position {i + 1}</Text>
				<Input
					icon="fas fa-bookmark"
					bind:value={favorite.name}
					label={$format('name')}
					disabled={!enabled}
					class="mb-s-plus"
					id="input-zah5byo"
					aria-labelledby="input-zah5byo"
				/>
				<div class="d-flex mb-s-plus">
					<Input
						type={'number'}
						bind:value={favorite.pos}
						disabled={!enabled}
						{min}
						{max}
						error={+favorite.pos < min || +favorite.pos > max
							? $format('error_out_of_range', {
									default: `Value ${favorite.pos}${unit} is out of range. Please provide a value within the limits. (${min}${unit} — ${max}${unit})`,
									values: { value: favorite.pos, max, min, unit },
								})
							: ''}
						id="input-iqskvlf"
						aria-label={$format('input_fav_pos', {
							default: 'Favorite positions input',
						})}
					/>
					<IconButton
						variant="secondary"
						class="ml-s"
						icon="fas fa-location-crosshairs"
						on:click={() => get_current_position(i, favorite)}
						disabled={!enabled || !calibrated}
						aria-label={$format('icon_button_get_pos', {
							default: 'Get current position',
						})}
					/>
				</div>
				<Button
					class="width-full"
					size="m"
					on:click={() => handle_save(i, favorite)}
					disabled={!enabled}
				>
					{$format('button_save')}
				</Button>
			</div>
			{#if i < favorites.length - 1}
				<hr class="mt-l mb-l" />
			{/if}
		{/each}
	{/if}
{:else}
	<Checkbox class="mb-s" checked={enabled} on:click={handle_enable} size="l" id="checkbox-xr9ep5h">
		{$format('checkbox_enable_favorite_positions', {
			default: 'Enable favorite positions',
		})}
	</Checkbox>
	<Text class="text-bold mb-m">{$format('favorite_posiotions')}</Text>
	{#each favorites as favorite, i}
		<Container type="modalContainer" padding="xs" class="mb-s border-color-transparent">
			<!-- {#if i !== 0}
				<hr class="mt-l mb-l" />
			{/if} -->
			<Input
				icon="fas fa-bookmark"
				bind:value={favorite.name}
				label={$format('name')}
				disabled={!enabled}
				class="mb-s"
				id="input-zah5byo"
				aria-labelledby="input-zah5byo"
			/>
			<div class="d-flex mb-s">
				<Input
					type={'number'}
					bind:value={favorite.pos}
					disabled={!enabled}
					{min}
					{max}
					error={+favorite.pos < min || +favorite.pos > max
						? $format('error_out_of_range', {
								default: `Value ${favorite.pos}${unit} is out of range. Please provide a value within the limits. (${min}${unit} — ${max}${unit})`,
								values: { value: favorite.pos, max, min, unit },
							})
						: ''}
					id="input-iqskvlf"
					aria-label={$format('input_fav_pos', {
						default: 'Favorite positions input',
					})}
				/>
				<IconButton
					variant="secondary"
					class="ml-s"
					icon="fas fa-crosshairs"
					on:click={() => get_current_position(i, favorite)}
					disabled={!enabled || !calibrated}
					aria-label={$format('icon_button_get_pos', {
						default: 'Get current position',
					})}
				/>
			</div>
			<Button
				class="width-full"
				size="m"
				on:click={() => handle_save(i, favorite)}
				disabled={!enabled}
			>
				{$format('button_save')}
			</Button>
		</Container>
	{/each}
{/if}
